import React from "react";
import PropTypes from "prop-types";
import { Progress } from "semantic-ui-react";

// Thin reusable wrapper around Semantic UI's <Progress>. Exposes a small
// value/total API, guards against invalid input (no NaN/Infinity bars), and
// clamps the rendered value so an over-count never overflows the bar.
function ProgressBar({
  value,
  total,
  label,
  color,
  size,
  indicating,
  autoSuccess,
  progress,
  ...rest
}) {
  const safeTotal = Number(total);
  const safeValue = Number(value);

  if (!Number.isFinite(safeTotal) || safeTotal <= 0 || !Number.isFinite(safeValue)) {
    return null;
  }

  const clampedValue = Math.min(Math.max(safeValue, 0), safeTotal);

  return (
    <Progress
      value={clampedValue}
      total={safeTotal}
      progress={progress}
      color={color}
      size={size}
      indicating={indicating}
      autoSuccess={autoSuccess}
      {...rest}
    >
      {label}
    </Progress>
  );
}

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  label: PropTypes.node,
  color: PropTypes.string,
  size: PropTypes.string,
  indicating: PropTypes.bool,
  autoSuccess: PropTypes.bool,
  progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

ProgressBar.defaultProps = {
  color: "blue",
  size: "small",
  progress: "ratio",
};

export default ProgressBar;
